import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Calendar, Zap } from 'lucide-react';
export function ProductPresentation() {
  const levels = ['Principiante', 'Intermedio', 'Avanzado', 'Adultos Mayores', 'Planificación', 'Natatorio y Club'];
  const topics = ['Fundamentos', 'Técnica', 'Los 4 Estilos', 'Corrección', 'Planificación', 'Preparación Física', 'Grupos Especiales', 'Seguridad', 'Evaluación', 'Progresión', 'Seguimiento', 'Virajes', 'Largadas', 'Liderazgo', 'Gestión', 'Negocio'];
  return <section className="bg-white py-8 sm:py-16 px-4 sm:px-6 lg:px-8" data-id="element-333">
      <div className="max-w-5xl mx-auto text-center" data-id="element-334">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-col items-center" data-id="element-335">
          <span className="bg-light text-agua font-bold px-4 py-1.5 rounded-full text-sm mb-4 border border-agua/20" data-id="element-336">
            Sistema N°1 para Profes de Natación en Argentina
          </span>

          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-deep mb-4 leading-tight" data-id="element-337">
            PROFE DE NATACIÓN RESUELTO™
            <span className="block text-2xl sm:text-3xl text-gray-600 font-bold mt-2" data-id="element-338">
              MEGAPACK — SISTEMA COMPLETO
            </span>
          </h2>

          <p className="text-lg sm:text-xl text-gray-600 font-medium mb-6 sm:mb-10" data-id="element-339">
            6 Tomos + 6 Bonos — Todos los niveles — Todo resuelto.
          </p>

          {/* Stats Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 sm:gap-6 w-full mb-6 sm:mb-12" data-id="element-340">
            <div className="bg-white rounded-2xl p-4 sm:p-6 shadow-sm border border-gray-100 flex flex-col items-center" data-id="element-341">
              <FileText className="w-8 h-8 text-agua mb-3" data-id="element-342" />
              <span className="text-4xl font-black text-agua mb-1" data-id="element-343">+600</span>
              <span className="text-gray-600 font-medium text-center" data-id="element-344">
                páginas estructuradas
              </span>
            </div>
            <div className="bg-white rounded-2xl p-4 sm:p-6 shadow-sm border border-gray-100 flex flex-col items-center" data-id="element-345">
              <Calendar className="w-8 h-8 text-agua mb-3" data-id="element-346" />
              <span className="text-4xl font-black text-agua mb-1" data-id="element-347">60+</span>
              <span className="text-gray-600 font-medium text-center" data-id="element-348">
                clases listas para dar
              </span>
            </div>
            <div className="bg-white rounded-2xl p-4 sm:p-6 shadow-sm border border-gray-100 flex flex-col items-center" data-id="element-349">
              <Zap className="w-8 h-8 text-agua mb-3" data-id="element-350" />
              <span className="text-4xl font-black text-agua mb-1" data-id="element-351">Hoy</span>
              <span className="text-gray-600 font-medium text-center" data-id="element-352">
                Funciona desde hoy mismo en tu pileta
              </span>
            </div>
          </div>

          {/* Levels & Topics */}
          <div className="w-full text-left bg-gray-50 rounded-2xl p-4 sm:p-8 border border-gray-100" data-id="element-353">
            <div className="mb-4 sm:mb-8" data-id="element-354">
              <h3 className="text-lg font-bold text-deep mb-4" data-id="element-355">
                Niveles y enfoques incluidos:
              </h3>
              <div className="flex flex-wrap gap-2" data-id="element-356">
                {levels.map((level, i) => <span key={i} className="bg-deep text-white px-4 py-2 rounded-full text-sm font-medium shadow-sm" data-id="element-357">
                    {level}
                  </span>)}
              </div>
            </div>

            <div data-id="element-358">
              <h3 className="text-lg font-bold text-deep mb-4" data-id="element-359">
                Todo lo que vas a dominar:
              </h3>
              <div className="flex flex-wrap gap-2" data-id="element-360">
                {topics.map((topic, i) => <span key={i} className="bg-light text-deep border border-agua/20 px-3 py-1.5 rounded-full text-xs sm:text-sm font-medium" data-id="element-361">
                    {topic}
                  </span>)}
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}